import React, { Component, Fragment } from 'react';
import Grid from '../../../component/form/Grid';
import withStyles from '@mui/styles/withStyles';
import { AltButton } from '../../../component/form/PrimaryButton';
import PrintContent from '../../../component/PrintContent';
import Table from '../../../component/form/Table';
import {
    CheckListTable,
    CoffinDetailsTable,
    DeceasedDetailsTable,
    formStyles,
    FuneralDetailsTable,
    MortuaryActionTable
} from './FormFields';
import PrintIcon from '../../../component/icon/PrintIcon';
import { dateTimeToString } from '../../../util/date';

class CheckoutForm extends Component {
    render() {
        return (
            <Fragment>
                <PrintContent
                    trigger={() => (
                        <AltButton>
                            <PrintIcon />
                            Print Checkout Form
                        </AltButton>
                    )}
                >
                    {this.renderForm()}
                </PrintContent>
            </Fragment>
        );
    }

    renderForm() {
        const { classes, form, mortuaryListData } = this.props;
        return (
            <div className={classes.root}>
                <Grid container spacing={3} className={classes.print}>
                    <Grid container item xs={12}>
                        <span className={classes.center}>Checkout Form - Printed {dateTimeToString(new Date())}</span>
                    </Grid>
                    <Grid item xs={12}>
                        <Table>
                            <DeceasedDetailsTable form={form} />
                        </Table>
                    </Grid>

                    <Grid item xs={12}>
                        <Table>
                            <CoffinDetailsTable form={form} />
                        </Table>
                    </Grid>

                    <Grid item xs={12}>
                        <Table>
                            <FuneralDetailsTable form={form} />
                        </Table>
                    </Grid>

                    <Grid item xs={12}>
                        <Table>
                            <CheckListTable form={form} />
                        </Table>
                    </Grid>

                    <Grid item xs={12}>
                        <Table>
                            <MortuaryActionTable data={mortuaryListData} />
                        </Table>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(formStyles)(CheckoutForm);
